import { apiAxios } from "@/api/axios";
let baseURL = 'https://rwhapi2.rakumart.cn'

export default {
  // 到货异常列表(代购系统)
  abnormalArrivalList: (data) => apiAxios('post', baseURL + '/api/abnormal.arrival.list', data),
  // 到货异常详情(代购系统)
  abnormalArrivalDetail: (data) => apiAxios('post', baseURL + '/api/abnormal.arrival.detail', data),
  // 处理到货异常(代购系统)
  abnormalArrivalHandle: (data) => apiAxios('post', baseURL + '/api/abnormal.arrival.handle', data),
}